export default [
    '/media-shuttle/account-administration/storage/signiant-server',
    '/media-shuttle/account-administration/security/saml',
    '/manager-agents/jobs/media-exchange/dropbox-monitor',
];
